import { style } from '@vanilla-extract/css';
import { headingTextPreset, spacingVars } from '@tundr/ds-foundations';

export const modalTitleClass = style({
  ...headingTextPreset,
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.lg,
  margin: 0,
});
